import React from "react";
import Label from "components/general/Label"
import DateTime from "components/presentation/DateTime"
import { isLiveStatus, isLessLiveStatus } from "helpers/status";
import Noc from "components/presentation/Noc";
import Competitor from "components/presentation/Competitor";
import Status from "components/presentation/Status";
import SportCode from "components/common/SportCode";
import { getDateTimeFormat } from "helpers/utils";


export function CompetitorBlock(competitor1) {
    const firstRoundCode = '1R'
    let competitor = JSON.parse(JSON.stringify(competitor1))
    let seed = ''
    let qualType
    let competitorBracket;
    if (competitor.co_seed) seed = '(' + competitor.co_seed + ')'
    if (competitor.cp_qual_types?.find(e => e.qualificationType)) qualType = competitor.cp_qual_types[0].qualificationType
    if (!competitor?.resultItem) {
        competitor.resultItem = {};

        if (Array.isArray(competitor?.participant?.athletes)) {
            competitor.resultItem.teamAthletes = []
        }


        Array.isArray(competitor?.participant?.athletes) && competitor?.participant?.athletes.forEach(item => {
            let obj = {};
            obj.order = item.order;
            obj.athlete = item.person;
            competitor.resultItem.teamAthletes.push(obj)
        })
    }

    if (competitor?.participant?.__typename === 'Person') {
        competitorBracket = <div><Competitor  {...competitor?.participant} hideNoc={true} hidePicture={true} noLink={true} onlyShortName={true} screen={competitor.screen} /></div>
    } else if (competitor?.resultItem?.teamAthletes) {
        competitorBracket = <div><Competitor hidePicture={true} hideNoc={true} noLink={true} teamAthletes={competitor?.resultItem?.teamAthletes} onlyShortName={true} screen={competitor.screen} /></div>
    } else {
        competitorBracket = <div><Competitor  {...competitor?.participant} hideNoc={true} hidePicture={true} noLink={true} onlyShortName={true} screen={competitor.screen} /></div>
    }

    if (competitor?.phase === firstRoundCode) {
        return (
            <div className="d-flex flex-row align-items-center">
                <div className='score-qualtype d-none d-md-block'>
                    {qualType && <span className="text-right"><SportCode entity='@QualifyingType' code={qualType} abbr={true} /></span >}
                    &nbsp;
                </div>
                <div className='score-competitor-container ten-container d-flex justify-content-start text-truncate align-items-center'>
                    <div className='score-noc'>
                        <Noc className='me-1' {...competitor?.participant?.organisation} />
                    </div>
                    <div className='score-name d-flex align-items-center'>
                        {competitorBracket}
                    </div>
                </div>
                <div><span className="text-right">{seed}</span></div>
            </div>
        )
    }
    return (
        <div className='score-competitor-container ten-container d-flex justify-content-start text-truncate align-items-center'>
            <div className='score-noc'>
                <Noc className='me-1' {...competitor?.participant?.organisation} />
            </div>
            <div className='score-name d-flex align-items-center'>
                {competitorBracket}
                <span><sup>{seed}</sup></span>
            </div>
        </div>
    )
}

export function Footer({ data }) {
    const formatDate = getDateTimeFormat('DayMonthShort')
    const formatDateTime = getDateTimeFormat('DayMonthShortHourMinute');

    const dateTime = data?.bi_date + ' ' + data?.bi_time
    const dateTimeFormated = data?.bi_date && <DateTime datetime={dateTime} format={formatDateTime} />
    const date = data?.bi_date && <><DateTime datetime={data?.bi_date} format={formatDate} /></>
    const dateComponent = data?.bi_time ? dateTimeFormated : date

    return (
        <>
            {isLiveStatus(data?.result?.status?.code) && <div className='score-status justify-content-end'>
                <Status typeToPrint={'result'} scheduleStatus={data?.schedule?.status?.code} resultStatus={data?.result?.status?.code} />
            </div>}
            {isLessLiveStatus(data?.result?.status?.code) &&
                <div className='row g-0 w-100'>
                    <div className='text-start col-3'>{dateComponent}</div>
                    <div className='text-end col-9'>{data?.schedule?.location?.shortDescription}</div>
                </div>}
        </>
    )
}